import { defineFcm } from '../shared/factory';

export const FCM_VIDEO_FIRST_PETITION_PAGE = defineFcm('video_first_petition_page')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		supportedGroups: { global: true },
		context: 'Petition details page',
		description: 'Controls whether the Video-First petition page treatment is enabled.',
		import: false,
	});
